export const authRoles = {
    sa: ['superuser'], // Only Super Admin has access
    admin: ['superuser', 'admin'], // Only SA & Admin has access
    editor: ['superuser', 'admin', 'inspector'], // Only SA & Admin & Editor has access
    guest: ['superuser', 'admin', 'inspector', 'guest'], // Everyone has access
}

// Check out app/views/dashboard/DashboardRoutes.js
// Only SA & Admin has dashboard access

// const dashboardRoutes = [
//   {
//     path: "/dashboard/analytics",
//     component: Analytics,
//     auth: authRoles.admin <===============
//   }
// ];

// Check navigaitons.js

// {
//   name: "Dashboard",
//   path: "/dashboard/analytics",
//   icon: "dashboard",
//   auth: authRoles.admin <=================
// }
